export const gitnum = {
      version: 'v1.0.30',
      git: '30',
      branch: 'main',
      commit: '9cec2de',
      describe: 'v1.0',
      date:'04/11/2025 15:56'
    };
    
